/**
 * Shared drag-and-drop auto-scroll configuration for vuedraggable (SortableJS) lists.
 * SortableJS's built-in auto-scroll moves at a constant speed whenever the pointer is within
 * [scrollSensitivity] px of a scrollable edge.  The custom scrollFn here replaces that with
 * speed that scales by proximity: gentle at the outer boundary of the zone, full speed at
 * (or beyond) the edge.
 */

const scrollSensitivity = 120; // px from the edge of the scroll region where auto-scroll begins
const scrollSpeed = 50; // px per 24ms auto-scroll tick when the pointer is at the very edge
const minSpeedFraction = 0.12; // fraction of scrollSpeed applied at the outer boundary of the zone

/**
 * SortableJS scrollFn, called on each auto-scroll tick with the constant-speed offsets SortableJS
 * would have applied (±scrollSpeed or 0).  Performs a proximity-scaled scroll instead; not
 * returning 'continue' suppresses SortableJS's own constant-speed scrollBy.
 */
function ProportionalScrollFn(offsetX, offsetY, originalEvent, touchEvt, scrollEl)
{
	let e = touchEvt || originalEvent;
	if (e && e.touches && e.touches.length)
		e = e.touches[0];
	if (!scrollEl || !e || typeof e.clientX !== "number")
		return 'continue';
	let bounds = GetScrollBounds(scrollEl);
	scrollEl.scrollLeft += ScaleOffset(offsetX, e.clientX, bounds.left, bounds.right);
	scrollEl.scrollTop += ScaleOffset(offsetY, e.clientY, bounds.top, bounds.bottom);
}
/** Returns the viewport-space bounds of the element's visible scroll region. */
function GetScrollBounds(el)
{
	if (el === document.scrollingElement || el === document.documentElement || el === document.body)
		return { left: 0, top: 0, right: window.innerWidth, bottom: window.innerHeight };
	return el.getBoundingClientRect();
}
/** Scales one axis of the constant-speed scroll offset by the pointer's proximity to the edge being scrolled toward. */
function ScaleOffset(offset, pointer, nearEdge, farEdge)
{
	if (!offset)
		return 0;
	let distance = offset > 0 ? farEdge - pointer : pointer - nearEdge;
	let proximity = 1 - Math.max(0, Math.min(1, distance / scrollSensitivity));
	let fraction = minSpeedFraction + ((1 - minSpeedFraction) * proximity * proximity);
	return offset * fraction;
}

/** Bind to a draggable component via v-bind to enable proximity-scaled drag auto-scrolling. */
export const DragAutoScrollOptions = {
	forceAutoScrollFallback: true,
	scrollSensitivity,
	scrollSpeed,
	scrollFn: ProportionalScrollFn
};
